import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import Select from "../../../../components/select/main/Select";
import ZoomPanEditor from "../../../../components/zoomPanEditor/ZoomPanEditor";
import { useLanguageContext } from "../../../../context/LanguageContext";
import { StyledAltButton } from "../../../../styles/ButtonStyles";
import { useLabelItemTypes } from "../label_items/LabelItems";
import PrintLabel from "./label/PrintLabel";

function LabelEditorView({
  zoomPanController,
  printerData,
  onItemPosChange,
  onItemAdd,
  onItemSelect,
  fields,
  images,
}) {
  const { translate } = useLanguageContext();
  const types = useLabelItemTypes();

  return (
    <OverlayLoader
      groups={"printer_page_fetch"}
      iconSize={"xl"}
      containerStyle={{ flex: 1 }}
    >
      <ZoomPanEditor
        controller={zoomPanController}
        customControls={
          <Select
            as={StyledAltButton}
            hideCaret={true}
            valueVisual={(val) =>
              translate("eva.main.entities.states.create", [
                {
                  key: "entities",
                  value: translate("eva.main.entities.printer_label_item"),
                },
              ])
            }
            options={types.map((type) => ({
              value: type,
              label: translate(`eva.main.printers.label.item.types.${type}`),
            }))}
            onChange={onItemAdd}
          />
        }
      >
        <PrintLabel
          printerData={printerData}
          zoomPanController={zoomPanController}
          onItemSelect={onItemSelect}
          onItemPosChange={onItemPosChange}
          fields={fields}
          images={images}
        />
      </ZoomPanEditor>
    </OverlayLoader>
  );
}

export default LabelEditorView;
